import React from 'react';
import PropTypes from 'prop-types';
import ExtensionsConstants from 'app/shared/constants/ExtensionsConstants';

// Constellation Components
import { FormHelp } from '@zillow/constellation';
import { Link } from '@zillow/zrs-comet';

// rmw context
import { RMWContext } from 'app/shared/providers/RMWContext';

import { Link as v4Link } from 'react-router-dom';

import pathsManifest from 'app/shared/pathsManifest';

const propTypes = {
    containsMultiple: PropTypes.bool,
};

const defaultProps = {
    containsMultiple: false,
};

const InvalidFiletypeText = (props) => {
    const photosText = props.containsMultiple ? 'One or more of your photos' : 'The photo';
    const infoText = `${photosText} you tried to upload is an unsupported file type.`;
    const linkText = ' Click here for more information';
    const fileTypeText = ' Only the following file types are accepted:';

    const getContext = () => RMWContext.Consumer._currentValue;

    const paths = pathsManifest.getAllPaths();

    return (
        <FormHelp error={true}>
            { infoText }

            {
                getContext().brand === 'zillow' ? (
                    <Link
                        reactRouterLink={v4Link}
                        to={paths.photosFormat}
                    >
                        { linkText }
                    </Link>

                ) : (
                    `${fileTypeText} ${Object.values(ExtensionsConstants).join(', ')}`
                )
            }
        </FormHelp>
    );
};

InvalidFiletypeText.propTypes = propTypes;
InvalidFiletypeText.defaultProps = defaultProps;

export default InvalidFiletypeText;
